module.exports = __webpack_public_path__ + "img/MEDIA052.40dee7a0.jpg";